import { types } from 'mobx-state-tree';


const PROPERTY_STYLES = {
    ONE_STOREY: 'one-storey',
    BI_LEVEL: 'bilevel',
    TWO_STOREY: 'two-storey',
    SPLIT_LEVEL: 'split-level',
    STOREY_AND_A_HALF: 'storey-and-a-half',
    THREE_STOREY: 'three-storey',
    OTHER: 'other',
    TWO_AND_A_HALF_STOREY: 'two-and-a-half-storey',
    THREE_AND_A_HALF_STOREY: 'three-and-a-half-storey',
    FOUR_STOREY: 'four-storey',
};

const PropertyStyleEnum = types.enumeration('PropertyStyle', Object.values(PROPERTY_STYLES));

export {
    PropertyStyleEnum,
};
export default PROPERTY_STYLES;
